<template>
  <b-layout v-if="waitlist" :colors="$site.colors" :header-title="title" :header-back-route="homeRoute">
    <b-container class="mt-12">
      <div class="max-w-lg mx-auto">
        <error v-if="error" :name="$t('pages.book.waitlist.complete.waitlist')" />

        <b-card v-else :title="$t('pages.book.waitlist.complete.onWaitlistTitle')" class="mb-6">
          <p class="text-sm text-secondary mb-2">
            <template v-for="(service, index) in waitlist.services">
              {{ index != 0 ? ',' : '' }}
              {{ service.employee ? $t('general.serviceWithEmployee', {service: service.service.title, employee: service.employee.displayName}) : service.service.title }}
            </template>
            {{ $t('general.on') }}
          </p>

          <ul class="list-disc ml-2 pl-2 mb-2 text-sm text-secondary">
            <li v-for="(date, index) in waitlist.dates" :key="index">
              {{ date.type == 'day' ? $t(`datetime.days.${date.day}`) : $format.date(date.date) }}
              {{ date.startTime && date.endTime ? `( ${$format.minuteTime(date.startTime)} - ${$format.minuteTime(date.endTime)} )` : '' }}
              {{ date.startTime && !date.endTime ? `( ${$format.minuteTime(date.startTime)} )` : '' }}
            </li>
          </ul>

          <p class="text-sm text-secondary">
            {{ waitlist.expires ? $t('pages.book.waitlist.complete.untilDate', {expires: $format.date(waitlist.expires)}) : '' }}
          </p>
        </b-card>
      </div>
    </b-container>
  </b-layout>
</template>

<script>
export default defineNuxtComponent({
  meta: {
    tabs: ['online'],
    middleware: ['redirects']
  },
  async asyncData (ctx) {
    const route = useRoute()
    const query = route.query

    const { $api } = useNuxtApp()

    try {
      if (query.id) {
        const response = await $api.customer.waitlist(query.id, query.signature)

        if (response.success) {
          return {
            waitlist: response.waitlist,
            error: false
          }
        } else {
          throw response.error
        }
      }
    } catch (error) {
      // ctx.$sentry.captureException(error)
    }

    return {
      waitlist: [],
      error: true
    }
  },
  data () {
    return {
    }
  },
  computed: {
    title () {
      return this.$t('pages.book.waitlist.complete.title')
    },
    homeRoute () {
      return this.$store.getters.homeRoute || { path: '/' }
    }
  },
  mounted () {
    const { gtag } = useGtag()
    
    gtag(
      'event',
      'added_to_waitlist',
      {
        event_category: 'waitlist',
        event_label: 'Added to waitlist',
        idCustomer: this.waitlist?.customer?.id,
      }
    )
  }
})
</script>

<style>
.times-list {
  list-style: none; padding: 0; margin: 0;
}

.times-list li {
  margin-bottom:10px;
  text-align:left !important;
}

.times-list li a{
  text-align:left !important;
  font-size: 14px;
}
</style>
